var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWave5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "wave",
    style: {
      transform: "rotate(0deg)",
      transition: "0.3s"
    },
    viewBox: "0 0 1440 370",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sw-gradient-0",
    x1: 0,
    x2: 0,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(249, 34, 75, 1)",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(249, 34, 75, 1)",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      transform: "translate(0, 0px)",
      opacity: 1
    },
    fill: "url(#sw-gradient-0)",
    d: "M0,296L1440,111L2880,185L4320,148L5760,74L7200,185L8640,222L10080,74L11520,333L12960,222L14400,222L15840,296L17280,148L18720,185L20160,111L21600,74L23040,0L24480,74L25920,185L27360,37L28800,148L30240,185L31680,296L33120,37L34560,74L34560,370L33120,370L31680,370L30240,370L28800,370L27360,370L25920,370L24480,370L23040,370L21600,370L20160,370L18720,370L17280,370L15840,370L14400,370L12960,370L11520,370L10080,370L8640,370L7200,370L5760,370L4320,370L2880,370L1440,370L0,370Z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave5);
export default __webpack_public_path__ + "static/media/wave-5.63e1ccabfd15244f130a539e07dc458c.svg";
export { ForwardRef as ReactComponent };